var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgWithdrawal = function SvgWithdrawal(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#397431",
    d: "M18.555 16.618A.99.99 0 0 1 19.47 16h27.54c.614 0 1.08.561.977 1.175l-6.747 39.99a.995.995 0 0 1-.977.835H2.992c-.708 0-1.187-.731-.914-1.394l16.477-39.988zm1.574 1.393L4.479 55.99h34.948l6.407-37.978H20.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397431",
    d: "M29.194 25.12a1.044 1.044 0 1 1 2.056.36l-.524 3.014c.936.189 1.92.446 2.953.773.55.174.855.762.682 1.314-.173.551-.76.858-1.309.684-1.693-.535-3.225-.867-4.593-.998-2.015-.192-3.4.251-3.827 1.159-.77 1.635-.12 2.967 3.165 4.093 4.528 1.553 5.935 4.466 4.664 7.159-.86 1.824-2.952 2.697-5.404 2.405l-.431 2.477a1.044 1.044 0 0 1-2.07-.247l.013-.114.432-2.475a74.9 74.9 0 0 1-3.36-.752 1.048 1.048 0 0 1 .497-2.034c1.812.446 3.44.788 4.886 1.026 1.772.29 3.094-.217 3.55-1.183.716-1.515-.058-3.115-3.452-4.28-4.414-1.514-5.703-4.153-4.378-6.97.896-1.904 3.12-2.615 5.912-2.35l.005.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "M3.025 8H61v18h-6.804a1 1 0 0 0 0 2H62a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1.025l.5 19.919a1 1 0 0 0 .972.974L5.475 28a1 1 0 0 0 .054-2l-2.054-.055L3.025 8z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWithdrawal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/withdrawal.47ed6c5d.svg";
export { ForwardRef as ReactComponent };